import axiosInstance from "./axiosInstance";

export const getWLData = async (forDomain) => {
    let url =  "rest/v1/whitelabel/all/" + btoa(forDomain);
    return await axiosInstance.get(url)
}